import { FilterSource, ProspectFilterField } from '../types';
import {
  ProspectFiltersSequencesClientsPayload,
  ProspectFiltersValuesPayload,
} from '../../../types';
import { isAgencyUser } from '../../../../../shared/utils/user-details';

type MakeProspectFilterFieldAttributeAPICalls = {
  field: ProspectFilterField;
  fieldData: any[];
  fetchField: boolean;
  sendValuesInPayload: boolean;
  fieldsLoading: Record<string, boolean>;
  fieldsFetched: Record<string, boolean>;
  value: (string | number)[];
  meta?: {
    page: number;
    pageSize: number;
    search: string;
  };
  sendGetProspectLeadFinderListsRequest: (payload: { key: string }) => void;
  sendGetProspectFiltersFieldValuesRequest: (
    payload: ProspectFiltersValuesPayload,
  ) => void;
  sendGetProspectFiltersAttributeFieldValuesRequest: (
    payload: ProspectFiltersValuesPayload,
  ) => void;
  sendGetProspectFiltersSequencesListRequest: (
    payload: ProspectFiltersSequencesClientsPayload,
  ) => void;
  sendGetProspectFiltersClientsListRequest: (
    payload: ProspectFiltersSequencesClientsPayload,
  ) => void;
  sendGetProspectFiltersSubsequenceListRequest: (
    payload: ProspectFiltersSequencesClientsPayload,
  ) => void;
  sendGetProspectFiltersTagsListRequest: VoidFunction;
  sendGetProspectFiltersOwnersListRequest: VoidFunction;
  sendGetProspectFiltersOwnersListForAgencyRequest: VoidFunction;
  sendGetProspectFiltersOutcomeListRequest: VoidFunction;
};

export const makeProspectFilterFieldAttributeAPICalls = ({
  field,
  fieldData,
  fetchField,
  sendValuesInPayload,
  fieldsLoading,
  fieldsFetched,
  meta,
  value,
  sendGetProspectFiltersFieldValuesRequest,
  sendGetProspectFiltersAttributeFieldValuesRequest,
  sendGetProspectFiltersSequencesListRequest,
  sendGetProspectFiltersClientsListRequest,
  sendGetProspectFiltersSubsequenceListRequest,
  sendGetProspectFiltersTagsListRequest,
  sendGetProspectFiltersOwnersListRequest,
  sendGetProspectFiltersOwnersListForAgencyRequest,
  sendGetProspectFiltersOutcomeListRequest,
  sendGetProspectLeadFinderListsRequest,
}: MakeProspectFilterFieldAttributeAPICalls) => {
  if (fieldData.length === 0 || meta || fetchField) {
    const fieldKey = (field?.key || '').toLowerCase();
    const fieldLabel = (field?.label || field?.value || '').toLowerCase();
    const isLeadFinderListField =
      (fieldKey.includes('lead') &&
        fieldKey.includes('finder') &&
        fieldKey.includes('list')) ||
      (fieldLabel.includes('lead finder') && fieldLabel.includes('list'));

    if (
      isLeadFinderListField &&
      !fieldsLoading?.[field.key] &&
      !fieldsFetched?.[field.key]
    ) {
      sendGetProspectLeadFinderListsRequest({ key: field.key });
      return;
    }

    if (
      field.source === FilterSource.TAGS &&
      !fieldsLoading?.[field.key] &&
      !fieldsFetched?.[field.key]
    ) {
      if (field.key === 'tags') {
        sendGetProspectFiltersTagsListRequest();
        return;
      }
    }

    if (
      field.source === FilterSource.SEQUENCES &&
      !fieldsLoading?.[field.key]
    ) {
      if (field.key === 'outcomes' && !fieldsFetched?.[field.key]) {
        sendGetProspectFiltersOutcomeListRequest();
        return;
      }

      if (
        field.key === 'sequence' &&
        (!fieldsFetched?.[field.key] || meta !== null)
      ) {
        sendGetProspectFiltersSequencesListRequest({
          page: meta?.page || 1,
          pageSize: 25,
          search: meta?.search || '',
          ...(sendValuesInPayload && { selectedIds: value }),
        });
        return;
      }

      if (
        field.key === 'clientSequenceAssociation' &&
        (!fieldsFetched?.[field.key] || meta !== null)
      ) {
        sendGetProspectFiltersClientsListRequest({
          page: meta?.page || 1,
          pageSize: 25,
          search: meta?.search || '',
          ...(sendValuesInPayload && { selectedIds: value }),
        });
        return;
      }

      if (
        field.key === 'subSequence' &&
        (!fieldsFetched?.[field.key] || meta !== null)
      ) {
        sendGetProspectFiltersSubsequenceListRequest({
          page: meta?.page || 1,
          pageSize: 25,
          search: meta?.search || '',
          ...(sendValuesInPayload && { selectedIds: value }),
        });
        return;
      }
    }

    if (
      field.source === FilterSource.PROSPECTS &&
      !fieldsLoading?.[field.key]
    ) {
      if (field.key === 'owners' && !fieldsFetched?.[field.key]) {
        if (isAgencyUser()) {
          sendGetProspectFiltersOwnersListForAgencyRequest();
        } else {
          sendGetProspectFiltersOwnersListRequest();
        }

        return;
      }

      if (!fieldsFetched?.[field.key] || meta !== null) {
        sendGetProspectFiltersFieldValuesRequest({
          key: field.key,
          page: meta?.page || 1,
          pageSize: 25,
          search: meta?.search || '',
          ...(sendValuesInPayload &&
            field.key === 'fileName' && { selectedIds: value }),
        });
      }
      return;
    }

    if (
      field.source === FilterSource.FIELD &&
      !fieldsLoading?.[field.id] &&
      (!fieldsFetched?.[field.id] || meta !== null)
    ) {
      sendGetProspectFiltersAttributeFieldValuesRequest({
        key: field.id,
        page: meta?.page || 1,
        pageSize: 25,
        search: meta?.search || '',
      });
    }
  }
};
